import React, { useState  }  from "react";
import CardItem from "components/card/CardItem";
import { ReactComponent as Logo } from 'assets/svg/intsamis_logo.svg';
import { connect } from "react-redux";
import { Scanner } from '@yudiel/react-qr-scanner';
import { Form } from 'antd';
import FormItem from "components/fields/FormItem";
import TextAreaField from "components/fields/TextAreaField";
import { useForm } from 'antd/lib/form/Form';
import Button from "components/button";
import { doCheckQRData, doCheckEncodedQRData } from "../../redux/auth/authState";
import HomeBanner from "components/banners/HomeBanner";
import base45 from "base45";
import CBOR from "cbor-web";

const ScanQR = ({checkQRData, checkEncodedQRData}) => {
  const [form] = useForm();
  const [qrCodeResult, setQrCodeResult] = useState("");
  const handleScan = (result) => {
    if (result) {
      let rawValue = result[0].rawValue;

      if (!rawValue) return;

      rawValue = rawValue.trim();

      if(rawValue.startsWith("PH1:")){ 
        // validate 
        const isValid = validatePhilSysQR(rawValue);
        console.log(isValid);

        checkEncodedQRData({data: rawValue});

      }else{
        setQrCodeResult(rawValue);
        checkQRData(JSON.parse(rawValue));
      }
    }
  };

  const validatePhilSysQR = (qr) => {
    try {
      const decodedBase45 = base45.decode(qr.substring(4)); // remove PH1: prefix
      CBOR.decodeFirstSync(decodedBase45);
      return true;
    } catch (err) {
      return false
    }
  };

  const onSubmit = (formData) => {	
    try {  
      checkQRData(JSON.parse(formData.qr_data));
    } catch (error) {
        console.error('Save failed:', error);
    }
  };

  return (
    <div className="m-4 mt-2 flex flex-col h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">      
      <HomeBanner/>

      <div className="form-column-2">
        <h1 className="font-montserrat mt-10 leading-none text-[30px] md:text-[60px] lg:text-[90px] font-black uppercase leading-none text-white text-center max-w-[300px] lg:max-w-[600px] mx-auto home-drop-shadow mb-4">
          DIGITAL LIVESTOCK PLATFORM
        </h1>
      
        <CardItem 
        extra="w-[300px] md:w-[400px] border-1 mx-auto"
        icon={<Logo/>}
        htmlTitle={<h4 className="ml-4 card-title text-3xl dark:text-theme-200">Scan QR Code</h4>}>
          <Form form={form} className="bg-white rounded-md dark:bg-intsamis-900"
            layout="vertical"
            onFinish={onSubmit}
            >   
            <div className="flex flex-col items-center mt-5">
              <div className="w-[250px] h-[250px]">
                <Scanner onScan={handleScan} />
              </div>
              <p className="text-center text-lg mb-3 mt-2">
                {qrCodeResult ? `Scanned Result: ${qrCodeResult}` : "Position your ID with the QR code facing the camera for scanning."}
              </p>
            </div>

            <div className="hidden">
              <FormItem 
                  name="qr_data"
                    label="QR Data"
                >
                  <TextAreaField id="qr_data"
                    rows={4}
                  />
                </FormItem>
            </div>      
            <Button className="hidden" type="submit">Submit</Button>
          </Form>
        </CardItem>
      </div>
      <div className="mt-8">
        <a className="crud-button" href="/home/da-doh">
          Back
        </a>
        <a className="crud-button" href="/auth/home">
          Refresh
        </a>
      </div>
      
    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({  
  checkQRData: (qrdata) => dispatch(doCheckQRData(qrdata)),
  checkEncodedQRData: (qrdata) => dispatch(doCheckEncodedQRData(qrdata)),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(ScanQR);